/** Formats exact decimal strings without Number, rounding, or loss of cents. */
export function formatMoney(value: string, kind: "amount" | "limit" = "amount", precision: number = kind === "limit" ? 0 : 2): string | null {
  return formatDecimal(value, precision);
}

export function formatDecimal(value: string, precision: number): string | null {
  if (!Number.isInteger(precision) || precision < 0 || precision > 18) return null;
  if (!/^-?(?:0|[1-9]\d*)(?:\.\d+)?$/.test(value)) return null;
  const negative = value.startsWith("-");
  const [whole = "0", fraction = ""] = value.replace(/^-/, "").split(".");
  if (/[^0]/.test(fraction.slice(precision))) return null;
  const integer = whole.replace(/^0+(?=\d)/, "");
  const decimals = fraction.slice(0, precision).padEnd(precision, "0");
  const sign = negative && /[1-9]/.test(integer + decimals) ? "-" : "";
  return `${sign}${integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}${precision ? `.${decimals}` : ""}`;
}

export function formatTokenQuantity(value: string, precision: number): string | null {
  return formatDecimal(value, precision);
}
